module.exports = __webpack_public_path__ + "static/media/logo.0350e5f3.svg";